import MainModal from '@/common/components/base/modal/Modal';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import { Box } from 'styled-system/jsx';
import { ShowDescriptionModalType } from '@/modules/FileDetail/components/statusTransition/modals/ShowDescriptionModal.type.ts';

const ShowDescriptionModal = ({
  closeModal,
  open,
  description,
}: ShowDescriptionModalType) => {
  return (
    <MainModal open={open} closeModal={closeModal}>
      <TitleDescription textStyle="h2" color="black-1">
        توضیحات
      </TitleDescription>
      <Box mt="24px" shadow="cardShadow" borderRadius="8px" p="16px">
        <Typography textStyle="b2" color="black-1">
          {description}
        </Typography>
      </Box>
    </MainModal>
  );
};
export default ShowDescriptionModal;
